import Entity from '../entity'

export default class Share extends Entity<number>{
    wxAppId: number  = null;
    shareUserWxUserId: number  = null;
    shareUserWxUserNo: string  = null;
    shareUserOpenId: string  = null;
    wxUserId: number  = null;
    wxUserNo: string  = null;
    openId: string  = null;
    tenantId: number  = null;
    remark: string  = null;
}